import { Route } from 'react-router-dom';
import RouteWithProfileCheck from '../components/RouteWithProfileCheck';
import Shipments from '../pages/Shipments';
import ShipmentDetail from '../pages/ShipmentDetail';
import Shipping from '../pages/Shipping';

export const ShipmentRoutes = () => {
    return (
        <>
            <Route path="/shipments" element={
                <RouteWithProfileCheck>
                    <Shipments />
                </RouteWithProfileCheck>
            } />
            <Route path="/shipments/:id" element={
                <RouteWithProfileCheck>
                    <ShipmentDetail />
                </RouteWithProfileCheck>
            } />
            <Route path="/shipments/:id/ship" element={
                <RouteWithProfileCheck>
                    <Shipping />
                </RouteWithProfileCheck>
            } />
            <Route path="/shipments/new" element={
                <RouteWithProfileCheck>
                    <Shipping />
                </RouteWithProfileCheck>
            } />
        </>
    );
}
